  import React from "react";
  import ImageUploader from "../../components/ImageUploader";

  const DynamicField = ({
    field,
    value,
    onChange,
  }) => {

    const handleImageUploadSuccess = (
      type,
      url
    ) => {
      onChange(type, url);
    };

    switch (field.type) {

      case "text":
        return (
          <input
            type="text"
            className="custom-ax-customize-cake-sec-input"
            placeholder={field.label}
            value={value || ""}
            required={field.required}
            minLength={field.min}
            maxLength={field.max}
            onChange={(e) =>
              onChange(
                field.key,
                e.target.value
              )
            }
          />
        );

      case "email":
        return (
          <input
            type="email"
            className="custom-ax-customize-cake-sec-input"
            placeholder={field.label}
            value={value || ""}
            required={field.required}
            onChange={(e) =>
              onChange(
                field.key,
                e.target.value
              )
            }
          />
        );

      case "phone":
        return (
          <input
            type="tel"
            className="custom-ax-customize-cake-sec-input"
            placeholder={field.label}
            value={value || ""}
            onChange={(e) =>
              onChange(
                field.key,
                e.target.value
              )
            }
          />
        );

      case "textarea":
        return (
          <textarea
            rows="4"
            className="custom-ax-customize-cake-sec-input"
            placeholder={field.label}
            value={value || ""}
            onChange={(e) =>
              onChange(
                field.key,
                e.target.value
              )
            }
          />
        );

      case "date":
        return (
          <input
            type="date"
            className="custom-ax-customize-cake-sec-input"
            value={value || ""}
            onChange={(e) =>
              onChange(
                field.key,
                e.target.value
              )
            }
          />
        );

      case "select":
        return (
          <select
            className="custom-ax-customize-cake-sec-input"
            value={value || ""}
            onChange={(e) =>
              onChange(
                field.key,
                e.target.value
              )
            }
          >
            <option value="">
              Select {field.label}
            </option>

            {field.options?.map(
              (option) => (
                <option
                  key={option}
                  value={option}
                >
                  {option}
                </option>
              )
            )}
          </select>
        );

      case "image":
        return (
          <ImageUploader
            type={field.key}
            label={field.label}
            value={value}
            assetType="customize"
            onUploadSuccess={
              handleImageUploadSuccess
            }
            onChange={(e) =>
              onChange(
                field.key,
                e.target.value
              )
            }
          />
        );

      default:
        return null;
    }
  };

  export default DynamicField;